<template>
  <div
    class="align-bottom items-center user-data"
    :class="{ 'user-data--min': verticalNavMenuItemsMin }">
    <div
      class="the-navbar__user-meta"
      v-if="verticalNavMenuItemsMin">
      <connected-switch
        :verticalNavMenuItemsMin="verticalNavMenuItemsMin"
        :userStatus="userStatus"
        @upateUserStatus="upateUserStatus" />
        
        <div style="position: relative; left: 15px; bottom: 1.3px;" v-if="incidentStatus !== 'UP'">
          <feather-icon
            class="incident-warning-icon"
            svgClasses="w-5 h-5 stroke-current"
            icon="AlertTriangleIcon"
          />
        </div>

      <trasferrer-drop-down :verticalNavMenuItemsMin="verticalNavMenuItemsMin" />

      <notification-drop-down
        :verticalNavMenuItemsMin="verticalNavMenuItemsMin" />

      <user-drop-down :verticalNavMenuItemsMin="verticalNavMenuItemsMin" />
    </div>
    
    <div
      class="the-navbar__user-meta flex"
      :class="{ 'items-center': verticalNavMenuItemsMin, 'flex-center': verticalNavMenuItemsMin }"
      v-else
      @mouseenter="$emit('mouseEnter')">
      <user-drop-down :verticalNavMenuItemsMin="verticalNavMenuItemsMin" />

      <div
        class="leading-tight sm:block ml-3 mr-3"
        v-if="!verticalNavMenuItemsMin">
        <p class="font-semibold">{{ activeUserInfo.name }}</p>
        <vs-row class="mt-2">
          <connected-switch
            v-if="!twoFactorActivated"
            :verticalNavMenuItemsMin="verticalNavMenuItemsMin"
            :userStatus="userStatus && !twoFactorActivated ? userStatus : false "
            @upateUserStatus="upateUserStatus" />

          <trasferrer-drop-down
            :verticalNavMenuItemsMin="verticalNavMenuItemsMin"
            class="mr-4" />
            
          <notification-drop-down :verticalNavMenuItemsMin="verticalNavMenuItemsMin" />

          <div style="position: relative; left: 17px; bottom: 1.3px;" v-if="incidentStatus !== 'UP'">
            <vx-tooltip :text="textIncident" position="top" >
              <feather-icon
              class="incident-warning-icon"
              svgClasses="w-5 h-5 stroke-current"
              icon="AlertTriangleIcon"
              />
            </vx-tooltip>
          </div>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
  import NotificationDropDown from './NotificationDropDown.vue';
  import TrasferrerDropDown from './TrasferrerDropDown.vue';
  import ConnectedSwitch from './ConnectedSwitch.vue';
  import UserDropDown from './UserDropDown.vue';

  import Vue              from '@/main'
  import moduleSettings from '@/store/settings/moduleSettings'

  export default {
    components: {
      NotificationDropDown,
      TrasferrerDropDown,
      ConnectedSwitch,
      UserDropDown
    },
    data: () => ({
      twoFactorActivated  : false,
      textIncident: "Estamos enfrentando algumas instabilidades em nossa plataforma no momento. Nossa equipe já está trabalhando para resolver o problema o mais rápido possível. Se precisar de suporte, entre em contato conosco, e faremos o possível para ajudá-lo."
    }),
    props: {
      verticalNavMenuItemsMin: {
        type: Boolean,
        required: true
      },
      userStatus: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      incidentStatus() {
        return this.$store.state.settings.incidentStatus
      }
    },
    methods: {
      upateUserStatus(userStatus) {
        this.$emit('upateUserStatus', userStatus);
      }
    },
    watch: {
      '$store.state.AppActiveUser': {
      handler(newVal, oldVal) {
          if (newVal.twofactor_activity && !newVal.is_two_factor_validated) {
            this.twoFactorActivated = true;
          } else {
            this.twoFactorActivated = false;
          }
        },
        deep: true
      }
    },
    created() {
      if (!moduleSettings.isRegistered) {
        this.$store.registerModule('settings', moduleSettings)
        moduleSettings.isRegistered = true
      }

      Vue.$events.off('NotifyIncident')
      Vue.$events.on('NotifyIncident', (event) => {
        this.$store.dispatch("settings/changeIncidentStatus", event.status)
      });
    },
    mounted() {
      this.$store.dispatch("settings/fetchGlobal")
    }
  }
</script>

<style lang="scss">

  .user-data {
    .the-navbar {
      &__user-meta {
        padding: 20px 15px;
      }
    }

    width: 100%;
    bottom: 0px;
    background: #f9f6f6;
    &--min {
      position: absolute;

      .the-navbar {
        &__user-meta {
          padding: 15px;
        }
      }
    }
  }

  .incident-warning-icon {
    cursor: pointer;
    svg{
      color:#ff6c00;
    }
  }

  .flex-center {
    justify-content: center;
  }
</style>
